export const generativeAiAgentIdLogRuns = "/generative_ai/agent/:id/logs/runs";
